import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { KeyValuePipe, NgForOf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SidenavContentRef } from '../../shared/sidenav/sidenav-content/sidenav-content-ref';
import { SIDENAV_CONTENT_DATA } from '../../shared/sidenav/sidenav-content/sidenav-content.service';
import { ButtonSpacerDirective } from '../../shared/directives/button.directive';
import { ConfigGeoRegions } from '../../../../config/geo-regions';
import { originalOrderFunction } from '../../../../functions/original-order';
import { GeoRegion } from '../../../shared/geo-region-selector/geo-region-selector.component';
import { SidenavContentModule } from '../../shared/sidenav/sidenav-content/sidenav-content.module';

export interface PmcFiltersSidenavInput {
    filters: { [key: string]: any };
}

export interface PmcFiltersSidenavOutput {
    success: true;
    filters: { [key: string]: any };
}

@Component({
    selector: 'app-company-filters-sidenav',
    templateUrl: './pmc-filters-sidenav.component.html',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        KeyValuePipe,
        MatButtonModule,
        ButtonSpacerDirective,
        NgForOf,
        SidenavContentModule,
    ],
})
export class PmcFiltersSidenavComponent
{
    formGroup = this._fb.nonNullable.group({
        state: this.data.filters.state || 'all',
    });

    readonly states: GeoRegion[] = ConfigGeoRegions.RegionsByCountry[0].regions;
    readonly originalOrder = originalOrderFunction;

    constructor(
            private _fb: FormBuilder,
            private _sidenavRef: SidenavContentRef<PmcFiltersSidenavComponent>,
            @Inject(SIDENAV_CONTENT_DATA) public data: PmcFiltersSidenavInput,
    ) {
    }

    applyFilters() {
        const output: PmcFiltersSidenavOutput = {
            success: true,
            filters: this.formGroup.value,
        };
        this._sidenavRef.close(output);
    }
}
